// The API rate-limits the seller OTP routes (uniquegiftapi app.js: send limits
// on signups / otplogin / resend, a login limit on verifyOtp) and answers
// 429 { status: 'error', message: 'Too many …' }. Show that message, not
// "Account not found" or "Invalid OTP", so the seller waits instead of retrying.
// Returns the message for a 429, else null.
export const rateLimitMessage = (error, fallback) =>
    error?.response?.status === 429 ? (error.response.data?.message || fallback) : null;
